import React, { useState } from "react";
import { useGoogleLogin } from "@react-oauth/google";
import axios from "axios";

const Emailthread = () => {
  const [threads, setThreads] = useState([]);
  const [openThreadIds, setOpenThreadIds] = useState([]);

  const handleConnectGmail = useGoogleLogin({
    scope: "https://mail.google.com/",

    flow: "auth-code", // Enable Authorization Code Flow
    access_type: "offline", // Required for refresh token
    prompt: "consent", // Force refresh token to be returned

    onSuccess: async (codeResponse) => {
      try {
        //const { access_token} = codeResponse;

        const { code } = codeResponse;

        // console.log("User Info:", data);
        // console.log("Authorization Code:", code);

        const threadRes = await axios.post(
          "http://localhost:4000/api/gmail/threads",
          { code }
        );

        // Attach email to each thread for display
        const threadsWithEmail = threadRes.data.threads.map((thread) => ({
          ...thread,
        }));

        setThreads(threadsWithEmail);
        console.log("Fetched Threads:", threadsWithEmail);
      } catch (error) {
        console.error("Login or fetch error:", error);
      }
    },
    onError: () => console.error("Login Failed"),
  });

  const toggleThread = (id) => {
    setOpenThreadIds((prev) =>
      prev.includes(id) ? prev.filter((tid) => tid !== id) : [...prev, id]
    );
  };

  return (
    <div className="p-4">
      <button
        onClick={() => handleConnectGmail()}
        className="bg-blue-500 text-white p-2 rounded"
      >
        Connect Gmail
      </button>

      <div className="mt-4 grid gap-4">
        {threads.map((thread) => (
          <div key={thread.id} className="bg-white p-4 rounded shadow">
            <div className="text-sm font-semibold text-blue-700">
              {thread.subject}
            </div>
            <div className="text-gray-700">{thread.snippet}</div>
            <div className="text-xs text-gray-500">{thread.timestamp}</div>
            <div className="text-xs text-green-600">
              Messages: {thread.count}
            </div>

            <button
              onClick={() => toggleThread(thread.id)}
              className="mt-2 text-blue-500 text-sm"
            >
              {openThreadIds.includes(thread.id)
                ? "Hide Conversation"
                : "Show Conversation"}
            </button>

            {openThreadIds.includes(thread.id) && (
              <div className="mt-2 ml-4 border-l pl-4 space-y-2">
                {thread.conversation.map((msg, idx) => (
                  <div key={idx} className="bg-gray-100 p-2 rounded">
                    <div className="text-xs text-gray-600">{msg.date}</div>
                    <div className="text-xs font-medium text-gray-800">
                      {msg.from}
                    </div>
                    <div className="text-sm text-gray-700">{msg.snippet}</div>
                  </div>
                ))}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default Emailthread;
